import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getClassName, THEMES } from '../../utils/ui'

/**
 * Button Component
 */
class Button extends PureComponent {
  /**
   * Render Button Component
   * @return {XML}
   */
  render () {
    const {
      className, theme, icon, label, linkTo, square, disabled, hidden, loading, onClick
    } = this.props

    const baseClassName = getClassName('button', [
      { condition: className, trueClassName: className },
      { condition: theme, trueClassName: `button--${theme}` },
      { condition: square, trueClassName: 'button--square' },
      { condition: disabled, trueClassName: 'button--disabled' },
      { condition: hidden, trueClassName: 'button--hidden' },
      { condition: loading, trueClassName: 'button--loading' }
    ])

    return linkTo ? (
      <Link className={baseClassName} to={linkTo}>
        {icon && <i className={`button_icon ${icon}`} />}
        {label && <span className='button_label'>{label}</span>}
      </Link>
    ) : (
      <button className={baseClassName} onClick={onClick}>
        {icon && <i className={`button_icon ${icon}`} />}
        {label && <span className='button_label'>{label}</span>}
      </button>
    )
  }
}

Button.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf([
    THEMES.RAIN, THEMES.STEEL, THEMES.CITRUS, THEMES.LIGHT_GREY, THEMES.SOFT_GREY, THEMES.TRANSPARENT
  ]),
  linkTo: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  square: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}

Button.defaultProps = {
  linkTo: null
}

export default Button
